import { expositionPreviewSchema } from "../schemas";
import {
  makeAnyKeySelector,
  makeCollectionSelector,
  makeAnyKeyCollectionSelector,
  makeFetchStatusSelector,
} from "./collections";

export const DEFAULT_COLLECTION = "index";

export function makeViewAnyKeySelector(key, collection) {
  return makeAnyKeySelector(key, collection, expositionPreviewSchema);
}

export function makeExpositionPreviewsSelector(collection = DEFAULT_COLLECTION) {
  return makeCollectionSelector(collection, expositionPreviewSchema);
}

export function makeExpositionPreviewsAnyKeySelector(key, collection = DEFAULT_COLLECTION) {
  return makeAnyKeyCollectionSelector(key, collection, expositionPreviewSchema);
}

export function makeExpositionPreviewsFetchStatusSelector(collection = DEFAULT_COLLECTION) {
  return makeFetchStatusSelector(collection, expositionPreviewSchema);
}
